import clsx from "clsx";
import { ComponentPropsWithoutRef, FunctionComponent } from "react";

import GeneralLinkButton from "@ui/components/cta/LinkButton";

import * as styles from "./LinkButton.css";

type Props = ComponentPropsWithoutRef<typeof GeneralLinkButton>;

const LinkButton: FunctionComponent<Props> = ({ className, ...props }) => (
  <GeneralLinkButton className={clsx(className, styles.button)} {...props} />
);

export default LinkButton;
